<template>
  <button @click="click">
    <slot />
  </button>
</template>

<script>
export default {
  name: 'BaseButton',

  methods: {
    click ($event) {
      this.$emit('click', $event)
    }
  }
}
</script>
